import { createContext, useContext } from 'react';
import type { ConfirmDialogProps } from '../components/ConfirmDialog';

export type DialogOptions = Omit<ConfirmDialogProps, 'open' | 'onCancel'> & {
    onCancel?: () => void;
};

export interface ConfirmDialogContextValue {
    openDialog: (options: DialogOptions) => void;
}

export const ConfirmDialogContext = createContext<ConfirmDialogContextValue | null>(null);

export const useConfirmDialog = (): ConfirmDialogContextValue => {
    const ctx = useContext(ConfirmDialogContext);
    if (!ctx) throw new Error('useConfirmDialog must be used within AppShell');
    return ctx;
}
